import React from 'react';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'emotion-theming';

import AcceptAgreementField from '../../registration/components/shared/AcceptAgreementField';
import { AcceptAgreementSchema } from '../../../shared/utils/loginSchemaHelper';
import Button from '../../../shared/_TBComponents/Button';
import setAcceptAgreement from '../ducks/acceptAgreementActions';
import Text from '../../../shared/_TBComponents/Text';

const AcceptAgreementForm = () => {
  const { accountCode } = useSelector((state) => state.auth.data.currentUser);
  const isLoading = useSelector((state) => state.acceptAgreement.ui.isLoading);

  const dispatch = useDispatch();
  const theme = useTheme();

  return (
    <Formik
      initialValues={{
        acceptAgreement: false,
      }}
      onSubmit={() => {
        dispatch(setAcceptAgreement(accountCode));
      }}
      validationSchema={AcceptAgreementSchema}
      render={({
        errors,
        touched,
        handleSubmit,
        values,
        setFieldValue,
      }) => (
        <>
          <Text
            styledTextProps={{ fontSize: '14px', fontWeight: 600, textAlign: 'center' }}
            styledWrapperProps={{ marginBottom: '15px' }}
          >
            There is no active license agreement for this account.
            You must accept the agreement below to continue using TeamBuildr.
          </Text>
          <AcceptAgreementField
            error={errors.acceptAgreement}
            setFieldValue={setFieldValue}
            showAgeNotice={false}
            touched={touched.acceptAgreement}
            values={{
              acceptAgreement: values.acceptAgreement,
            }}
          />
          <Button
            bgColor={theme.colors.orange}
            disabled={errors.acceptAgreement || isLoading || !values.acceptAgreement}
            fontSize='14px'
            fullWidth
            large
            lightSpinner
            name='submit'
            noBorder
            onClick={handleSubmit}
            type='button'
            isLoading={isLoading}
            rounded
            txtColor={theme.colors.white}
            upperCase
            styledWrapperProps={{ marginTop: '30px' }}
          />
        </>
      )}
    />
  );
};

export default AcceptAgreementForm;
